import { render, staticRenderFns } from "./EmailOTP.vue?vue&type=template&id=298f96e4&"
import script from "./EmailOTP.vue?vue&type=script&lang=js&"
export * from "./EmailOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298f96e4')) {
      api.createRecord('298f96e4', component.options)
    } else {
      api.reload('298f96e4', component.options)
    }
    module.hot.accept("./EmailOTP.vue?vue&type=template&id=298f96e4&", function () {
      api.rerender('298f96e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/EmailOTP.vue"
export default component.exports